import {createSlice} from '@reduxjs/toolkit';
import {INT_BASE, LETTER_SERIES, MAND_USER_WINDOW, NB_SCREEN} from '../../../constants/Lookup';
import {httpPost, httpGet} from '../../../util/Rest';
import {CLIENT_MAINTENANCE} from '../../../constants/MicroServiceConstants';

const initialData = {
  newBusinessData: {},
  dropDownData: {},
  newBusinessStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'NewBusiness',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchNewBusinessData: (state, action) => {
      state.newBusinessData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postNewBusinessData: (state, action) => {
      state.newBusinessStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetNewBusiness: (state) => {
      state.newBusinessStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {
  fetchStart,
  fetchNewBusinessData,
  fetchDropDownData,
  fetchError,
  postNewBusinessData,
  resetMsg,
  resetNewBusiness,
} = slice.actions;
export const fetchDropdown = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [LETTER_SERIES, MAND_USER_WINDOW, NB_SCREEN, INT_BASE],
      }),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const fetchNewBusiness = (clientNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${CLIENT_MAINTENANCE}/find/clientnewbusiness/${clientNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchNewBusinessData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const postNewBusiness = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${CLIENT_MAINTENANCE}/save/clientnewbusiness`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postNewBusinessData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetStatus = () => {
  return (dispatch) => {
    dispatch(resetNewBusiness());
  };
};
